var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import cn from 'classnames';
import '@cb/apricot/CBGlyph';
export const multiContentGlyphSizes = ['64', '72', '96'];
export const multiGlyphColors = [
    'black1',
    'blue2',
    'blue3',
    'blue4',
    'purple1',
    'purple2',
    'green1',
    'green2',
    'white',
    'yellow1',
];
export const MulticolorContentGlyph = (_a) => {
    var { glyphId, name, size, color, className, decorative = false } = _a, props = __rest(_a, ["glyphId", "name", "size", "color", "className", "decorative"]);
    const newClassName = cn('cb-glyph-content-multi', `cb-${name}`, size && `cb-glyph-${size}`, color && `cb-glyph-${color}`, className);
    return (React.createElement("span", Object.assign({ id: glyphId, className: newClassName, "aria-hidden": decorative, "data-cbtrack-comp": "apricot-react:glyph" }, props)));
};
//# sourceMappingURL=MulticolorContentGlyph.js.map